import { Button } from "@/components/ui/button";
import type { PropsWithChildren } from "react";

interface FormStickyActionsProps extends PropsWithChildren {
  primaryLabel?: string;
  secondaryLabel?: string;
  onPrimary?: () => void;
  onSecondary?: () => void;
  isPending?: boolean;
  pendingLabel?: string;
  secondaryVariant?: "secondary" | "outline";
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
}

export function FormStickyActions({
  primaryLabel,
  secondaryLabel,
  onPrimary,
  onSecondary,
  isPending = false,
  pendingLabel,
  secondaryVariant = "secondary",
  children,
  className,
  style,
  disabled = false,
}: FormStickyActionsProps) {
  const label = isPending && pendingLabel ? pendingLabel : primaryLabel;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-30 bg-background/95 backdrop-blur border-t border-border lg:left-[var(--sidebar-offset)] lg:right-[var(--ai-panel-offset)] transition-all duration-300 ${
        className || ""
      }`}
      style={style}
    >
      <div className="max-w-4xl px-4 py-4 lg:px-6 lg:py-4 flex items-center justify-start gap-4">
        <div className="flex items-start gap-3">
          {children ? (
            children
          ) : (
            <>
              {primaryLabel && (
                <Button
                  type={onPrimary ? "button" : "submit"}
                  onClick={onPrimary}
                  disabled={isPending || disabled}
                  className="h-10"
                  style={{ height: "40px" }}
                >
                  {label}
                </Button>
              )}
              {secondaryLabel && (
                <Button
                  type="button"
                  variant={secondaryVariant}
                  onClick={onSecondary}
                  disabled={isPending}
                  className="h-10"
                  style={{ height: "40px" }}
                >
                  {secondaryLabel}
                </Button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

/**
 * Компенсатор высоты sticky bar для форм
 * Добавьте в конец формы перед закрывающим тегом, чтобы контент не обрезался
 */
export function FormSpacer() {
  return <div className="h-[100px]" aria-hidden="true" />;
}
